import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    settingsHeading: {
      padding: '24px 40px',
      justifyContent: 'space-between',
      background: 'transparent',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        gap: '20px'
      },
      [theme.breakpoints.only('sm')]: {
        padding: '18px 20px 18px 20px'
      },
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '18px 0px 18px 0px',
        height: '100%'
      },
      [theme.breakpoints.down('sm')]: {
        height: '100px'
      }
    },
    settingsHeaderText: {
      lineHeight: '1',
      fontSize: '40px',
      letterSpacing: 'normal',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: '36px'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '32px'
      },
      [theme.breakpoints.only('md')]: {
        fontSize: '36px'
      }
    },
    errorOverlayHeader: {
      textAlign: 'center',
      fontSize: '48px',
      margin: '0px 10px',
      [theme.breakpoints.only('sm')]: {
        fontSize: '30px'
      },
      [theme.breakpoints.only('xs')]: {
        fontSize: '24px'
      }
    },
    salesReportButton: {
      margin: '32px 0 0 20px',
      width: '145px'
    },
    configSettingLabel: {
      textAlign: 'center',
      fontSize: '24px',
      marginRight: '20px',
      [theme.breakpoints.only('xs')]: {
        fontSize: '20px',
        whiteSpace: 'normal'
      }
    },
    contentBox: {
      height: '80px',
      width: '40%',
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      }
    }
  })
);
